module.exports = __webpack_public_path__ + "static/media/10.eaa1804a.jpg";